import Eye from "../eye.svg";
import Next from "../next.svg";
import Success from "../success.svg";

import Logo from "../logo@2x.png";
import Cart from "../cart@2x.png";
import Store from "../store@2x.png";
import Account from "../account@2x.png";
import Home from "../home@2x.png";
import AccountSelected from "../account_selected@2x.png";
import Search from "../search@2x.png";
import Back from "../back@2x.png";
import Location from "../location@2x.png";
import Add from "../add@2x.png";
import Decrement from "../decrement@2x.png";
import Increment from "../increment@2x.png";
import CartEmpty from "../cartEmpty@2x.png";
import Chevron from "../chevron@2x.png";
import BlueMenu from "../blueMenu@2x.png";
import OrangeMenu from "../orangeMenu@2x.png";
import CheckBlue from "../checkBlue@2x.png";
import CheckOrange from "../checkOrange@2x.png";
import Edit from "../edit@2x.png";
import AddSquare from "../addSq@2x.png";
import EmptyStore from "../emptyStore@2x.png";
import Delete from "../delete@2x.png";
import Gps from "../gps@2x.png";
import Marker from "../maps-and-flags@2x.png";
import PhonePe from "../phonepe@2x.png";
import Gpay from "../gpay@2x.png";
import Bhim from "../bhim@2x.png";
import Paytm from "../paytm@2x.png";
import Camera from "../camera@2x.png";
import Order from "../order@2x.png";
import Settings from "../setting@2x.png";
import Navigation from "../navigation@2x.png";
import Down from "../down@2x.png";
import SendOff from "../send_off@2x.png";
import SendOn from "../send_on@2x.png";
import Orders from "../orders@2x.png";
import OrdersSelected from "../orders_selected@2x.png";
import Items from "../items@2x.png";
import ItemsSelected from "../items_selected@2x.png";
import Menu from "../menu@2x.png";
import InStore from "../in-store@2x.png";
import Instant from "../instant@2x.png";
import Scheduled from "../scheuled@2x.png";
import About from "../about@2x.png";
import Close from "../close@2x.png";
import EditItem from "../edit-item@2x.png";
import CameraPick from "../camera-pick@2x.png";
import Stop from "../stop@2x.png";
import NoResult from "../no-results@2x.png";
import NoImage from "../noImage@2x.png";

import Oil from "../oil@2x.png";
import Shampoo from "../shampoo@2x.png";
import Cleaning from "../cleaning@2x.png";
import Beverage from "../beverage@2x.png";
import Cake from "../cake@2x.png";
import Meat from "../meat@2x.png";
import Mortar from "../mortar@2x.png";
import Rice from "../rice@2x.png";
import Fruit from "../fruit@2x.png";
import PetFood from "../pet-food@2x.png";
import Profile from "../profile@2x.png";
import Cashier from "../cashier@2x.png"
import Transaction from "../transaction@2x.png"

export { Eye, Next, Success };

export const ImageAssets = [
  Transaction,
  Profile,
  PetFood,
  Oil,
  Shampoo,
  Cleaning,
  Beverage,
  Cake,
  Meat,
  Mortar,
  Rice,
  Fruit,
  NoResult,
  NoImage,
  CameraPick,
  EditItem,
  Stop,
  Close,
  About,
  InStore,
  Instant,
  Scheduled,
  Menu,
  Orders,
  OrdersSelected,
  Items,
  ItemsSelected,
  Logo,
  Cart,
  Store,
  Account,
  Home,
  AccountSelected,
  Search,
  Back,
  Location,
  Add,
  Decrement,
  Increment,
  CartEmpty,
  Chevron,
  BlueMenu,
  OrangeMenu,
  CheckBlue,
  CheckOrange,
  Edit,
  AddSquare,
  EmptyStore,
  Delete,
  Gps,
  Marker,
  PhonePe,
  Paytm,
  Gpay,
  Bhim,
  Camera,
  Order,
  Settings,
  Navigation,
  Down,
  SendOff,
  SendOn,
  Cashier
];

export const ImageMapper = {
  Transaction: "transaction",
  Cashier: 'cashier',
  Profile: 'profile',
  PetFood: "pet-food",
  Oil: "oil",
  Shampoo: "shampoo",
  Cleaning: "cleaning",
  Beverage: "beverage",
  Cake: "cake",
  Meat: "meat",
  Mortar: "mortar",
  Rice: "rice",
  Fruit: "fruit",
  Logo: "logo",
  NoResult: "no-results",
  Stop: "stop",
  Cart: "cart",
  Store: "store",
  Account: "account",
  Home: "home",
  AccountSelected: "account_selected",
  Search: "search",
  Back: "back",
  Location: "location",
  Add: "add",
  Decrement: "decrement",
  Increment: "increment",
  CartEmpty: "cartEmpty",
  Chevron: "chevron",
  BlueMenu: "blueMenu",
  OrangeMenu: "orangeMenu",
  CheckBlue: "checkBlue",
  CheckOrange: "checkOrange",
  Edit: "edit",
  AddSquare: "addSq",
  EmptyStore: "emptyStore",
  Delete: "delete",
  Gps: "gps",
  Marker: "maps-and-flags",
  PhonePe: "phonepe",
  Gpay: "gpay",
  Bhim: "bhim",
  Paytm: "paytm",
  Camera: "camera",
  Order: "order",
  Settings: "setting",
  Navigation: "navigation",
  Down: "down",
  SendOff: "send_off",
  SendOn: "send_on",
  Orders: "orders",
  OrdersSelected: "orders_selected",
  Items: "items",
  ItemsSelected: "items_selected",
  Menu: "menu",
  InStore: "in-store",
  Instant: "instant",
  Scheduled: "scheuled",
  About: "about",
  Close: "close",
  EditItem: "edit-item",
  CameraPick: "camera-pick",
  NoImage: "noImage",
};
